import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";
import { queryClient } from "services/queryClient";

export const usePublishDiscountMutation = () => {
  return useMutation({
    mutationFn: (id: any) =>
      axiosInstance
        .patch("/discounts/publish", { ids: [id] })
        .then((res: any) => res.data),
    onSuccess: async (data: any) => {
      queryClient.invalidateQueries({ queryKey: ["useGetDiscountQuery"] });
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.message);
    },
  });
};
